/**
 * Utility/Tractor Loan Insert Service
 * Migrated from 3in1cms legacy/utlInsertApi.ts
 */

import { request } from "../core/request";
import { API_RESPONSE_CODES, OPERATION_IDS } from "./constants";
import type { ITfInsertApiRequest, ITfInsertApiResponse } from "../types/utlInsertType";

/**
 * Utility/Tractor Loan Insert API
 * @param requestData - Utility loan insert request data
 * @returns Promise of Utility loan insert response
 */
export const utlInsert = async (
  requestData: ITfInsertApiRequest
): Promise<ITfInsertApiResponse> => {
  const response = (await request<ITfInsertApiResponse>({
    operationId: OPERATION_IDS.utlInsert,
    requestData,
  })) as ITfInsertApiResponse;

  if (response.statusCode !== API_RESPONSE_CODES.STATUS_CODE_7001) {
    throw new Error(JSON.stringify(response));
  }

  return response;
};
